import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { ArianeTranslationPipe } from '@app/shared/pipes/ariane-translation.pipe';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  title = inject(Title);

  constructor(private readonly _arianePipe: ArianeTranslationPipe) {
    super();
  }

  updateTitle(snapshot: RouterStateSnapshot): void {
    const url = snapshot.url;
    const parsedUrl = url.includes(';') ? url.substring(0, url.indexOf(';')) : url;
    const arianeTranslation = this._arianePipe.transform(parsedUrl);
    const staticTitle = 'Vet Services - Royal Canin';
    let customTitle: string[] = [];

    if (arianeTranslation !== '--' && arianeTranslation && arianeTranslation[0]) {
      customTitle = arianeTranslation;
    } else {
      customTitle = parsedUrl
        .split('/')
        .map((s) => this._arianePipe.transform(s))
        .filter((s) => s !== '--');
    }

    const joinTitle = Array.isArray(customTitle) ? customTitle.join(' | ') : customTitle;
    if (joinTitle.length && joinTitle !== '--') {
      const newTitle = `${joinTitle} - ${staticTitle}`;
      this.title.setTitle(newTitle);
    } else {
      this.title.setTitle(staticTitle);
    }
  }
}
